(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  // Quantity controls functionality
  document.addEventListener('DOMContentLoaded', function () {
    const quantityControls = document.querySelectorAll('.cart-item__quantity');

    quantityControls.forEach((control) => {
      const minusBtn = control.querySelector('[data-quantity-minus]');
      const plusBtn = control.querySelector('[data-quantity-plus]');
      const input = control.querySelector('[data-quantity-input]');

      if (!minusBtn || !plusBtn || !input) return;

      function updateQuantity(newQuantity) {
        if (newQuantity < 0) newQuantity = 0;
        input.value = newQuantity;

        // Auto-submit form after short delay
        clearTimeout(window.quantityUpdateTimer);
        window.quantityUpdateTimer = setTimeout(() => {
          const form = input.closest('form');
          if (form) {
            const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
            form.dispatchEvent(submitEvent);
            if (!submitEvent.defaultPrevented) {
              form.submit();
            }
          }
        }, 500);
      }

      minusBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const currentValue = parseInt(input.value) || 0;
        updateQuantity(currentValue - 1);
      });

      plusBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const currentValue = parseInt(input.value) || 0;
        updateQuantity(currentValue + 1);
      });
    });

    const cartForm = document.querySelector('.cart-form');
    const cartDeliveryWindow = document.querySelector('.cart-delivery-window');
    const deliveryFieldsWrapper = cartDeliveryWindow
      ? cartDeliveryWindow.querySelector('[data-delivery-fields]')
      : null;
    const deliveryDatetime = document.querySelector('#cart-delivery-datetime');

    function normalizeCap(value) {
      return value ? value.toString().replace(/\s+/g, '').toLowerCase() : '';
    }

    function parseCaps(rawValue) {
      if (!rawValue) return [];
      try {
        const parsed = JSON.parse(rawValue);
        if (Array.isArray(parsed)) {
          return parsed;
        }
      } catch (error) {
        return rawValue.split(/[,\s]+/);
      }
      return [];
    }

    if (cartDeliveryWindow) {
      const requiresCap = cartDeliveryWindow.getAttribute('data-requires-cap') === 'true';
      const rawCaps = cartDeliveryWindow.getAttribute('data-available-caps');
      const availableCaps = parseCaps(rawCaps)
        .map((cap) => normalizeCap(cap))
        .filter((cap) => cap.length);
      const capField = cartDeliveryWindow.querySelector('.cart-delivery-cap-field');
      const capInput = capField
        ? capField.querySelector('input[name="attributes[Delivery postal code]"]')
        : null;
      const capMessage = capField ? capField.querySelector('.delivery-cap-message') : null;

      const updateCapState = () => {
        if (!deliveryFieldsWrapper) return;

        if (!requiresCap || !capField || !capInput) {
          deliveryFieldsWrapper.style.display = '';
          return;
        }

        const normalizedValue = normalizeCap(capInput.value);
        const hasValue = normalizedValue.length > 0;
        const capAllowed = hasValue && (!availableCaps.length || availableCaps.includes(normalizedValue));

        capField.classList.remove('is-error', 'is-valid');
        if (capMessage) {
          capMessage.textContent = '';
        }

        if (!hasValue) {
          deliveryFieldsWrapper.style.display = 'none';
          if (deliveryDatetime) {
            deliveryDatetime.value = '';
          }
          return;
        }

        if (capAllowed) {
          deliveryFieldsWrapper.style.display = '';
          if (capMessage) {
            capMessage.textContent = capField.getAttribute('data-valid-message') || '';
          }
          capField.classList.add('is-valid');
        } else {
          deliveryFieldsWrapper.style.display = 'none';
          if (deliveryDatetime) {
            deliveryDatetime.value = '';
          }
          if (capMessage) {
            capMessage.textContent = capField.getAttribute('data-invalid-message') || '';
          }
          capField.classList.add('is-error');
        }
      };

      if (capInput) {
        capInput.addEventListener('input', updateCapState);
        capInput.addEventListener('blur', updateCapState);
        updateCapState();
      } else if (deliveryFieldsWrapper) {
        deliveryFieldsWrapper.style.display = '';
      }
    }

    // Terms checkbox validation
    const termsCheckbox = document.querySelector('#cart-terms');
    const checkoutBtn = document.querySelector('.btn-checkout');

    if (termsCheckbox && checkoutBtn) {
      function updateCheckoutButton() {
        checkoutBtn.disabled = !termsCheckbox.checked;
      }

      // Delivery window validation
      if (cartForm && deliveryDatetime) {
        cartForm.addEventListener('submit', function (e) {
          const fieldsVisible = deliveryFieldsWrapper
            ? deliveryFieldsWrapper.offsetParent !== null
            : deliveryDatetime.offsetParent !== null;

          if (fieldsVisible && !deliveryDatetime.value) {
            e.preventDefault();
            deliveryDatetime.focus();
            alert('Please select a delivery date and time before proceeding to checkout.');
            return false;
          }
        });
      }
      termsCheckbox.addEventListener('change', updateCheckoutButton);
      updateCheckoutButton(); // Initialize state
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["events-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const filters = document.querySelectorAll('[data-filter]');

    filters.forEach((filter) => {
      filter.addEventListener('change', function () {
        // Implement filter logic here
        console.log('Event filter changed:', this.dataset.filter, this.value);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-signup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var toArray = function (nodes) {
      return Array.prototype.slice.call(nodes || []);
    };

    var getShopifyRoot = function () {
      if (window.Shopify && window.Shopify.routes && typeof window.Shopify.routes.root === 'string') {
        return window.Shopify.routes.root;
      }
      return '/';
    };

    var SHOPIFY_ROOT = getShopifyRoot();

    var joinWithRoot = function (path) {
      if (!path || typeof path !== 'string') {
        return SHOPIFY_ROOT;
      }

      var root = SHOPIFY_ROOT;
      if (!root.endsWith('/')) {
        root += '/';
      }

      if (path.startsWith('/')) {
        path = path.substring(1);
      }

      return root + path;
    };

    var sanitizePath = function (path) {
      if (!path) return '/contact';
      if (path.indexOf('{') !== -1) {
        return '/contact';
      }
      return path;
    };

    var getErrorMessage = function (errors) {
      if (!errors) return '';
      if (Array.isArray(errors)) return errors.join(', ');
      if (typeof errors === 'string') return errors;
      if (errors.email) {
        return Array.isArray(errors.email) ? errors.email.join(', ') : String(errors.email);
      }
      return '';
    };

    var bindWrapper = function (wrapper) {
      if (!wrapper) return;

      var form = wrapper.querySelector('[data-newsletter-form]');
      if (!form || form.dataset.mpNewsletterBound === 'true') return;
      form.dataset.mpNewsletterBound = 'true';

      var button = form.querySelector('button[type="submit"]');
      var emailInput = form.querySelector('input[name="contact[email]"]');
      var messageEl = wrapper.querySelector('[data-newsletter-message]');

      if (messageEl && !wrapper.dataset.defaultMessage) {
        wrapper.dataset.defaultMessage = messageEl.textContent.trim();
      }

      var resolveRequestPath = function () {
        var rawAction = form.getAttribute('action') || '';
        if (!rawAction) return '/contact';

        try {
          var parsed = new URL(rawAction, window.location.origin);
          var endpoint = parsed.pathname + (parsed.search || '');
          return sanitizePath(endpoint || '/contact');
        } catch (error) {
          if (rawAction.indexOf('http') === 0) {
            try {
              var parsedAbsolute = new URL(rawAction);
              return sanitizePath(parsedAbsolute.pathname + (parsedAbsolute.search || ''));
            } catch (err) {
              console.warn('Unable to parse form action URL:', err);
              return '/contact';
            }
          }

          return sanitizePath(rawAction);
        }
      };

      var messages = {
        success: wrapper.getAttribute('data-success-message') || '',
        error: wrapper.getAttribute('data-error-generic') || '',
        captcha: wrapper.getAttribute('data-captcha-error') || '',
        default: wrapper.getAttribute('data-default-message') || (messageEl ? messageEl.textContent.trim() : ''),
      };

      var CAPTCHA_TIMEOUT = 10000;

      var wireCaptcha = function () {
        if (!(window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function')) {
          return;
        }

        if (form.dataset.mpCaptchaWired === 'true') {
          return;
        }

        try {
          window.Shopify.captcha.protect(form, function () {
            form.dataset.mpCaptchaWired = 'true';
          });
        } catch (error) {
          console.warn('Captcha protect error:', error);
        }
      };

      wireCaptcha();

      var setMessage = function (type, text) {
        if (!messageEl) return;
        messageEl.classList.remove('mp-nl-form__status--success', 'mp-nl-form__status--error');

        if (type === 'success') {
          messageEl.classList.add('mp-nl-form__status--success');
          messageEl.textContent = text || messages.success || messages.default;
        } else if (type === 'error') {
          messageEl.classList.add('mp-nl-form__status--error');
          messageEl.textContent = text || messages.error || messages.default;
        } else {
          messageEl.textContent = messages.default;
        }
      };

      var setLoading = function (state) {
        if (!button) return;
        button.disabled = !!state;
        button.classList.toggle('is-loading', !!state);
        if (state) {
          button.setAttribute('aria-busy', 'true');
        } else {
          button.removeAttribute('aria-busy');
        }
      };

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        setMessage('default');

        if (!emailInput) return;

        var emailValue = emailInput.value ? emailInput.value.trim() : '';
        if (!emailValue) {
          setMessage('error');
          emailInput.focus();
          return;
        }

        setLoading(true);

        var runCaptcha = function () {
          wireCaptcha();

          if (!(window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.execute === 'function')) {
            return Promise.resolve();
          }

          return new Promise(function (resolve, reject) {
            var resolved = false;
            var timeoutId = window.setTimeout(function () {
              if (!resolved) {
                reject(new Error('captcha-timeout'));
              }
            }, CAPTCHA_TIMEOUT);

            window.Shopify.captcha.execute(form, function (token) {
              if (resolved) return;
              resolved = true;
              window.clearTimeout(timeoutId);
              if (token) {
                resolve(token);
              } else {
                reject(new Error('captcha-failed'));
              }
            });
          });
        };

        runCaptcha()
          .then(function (token) {
            var formData = new FormData(form);
            formData.set('contact[email]', emailValue);
            if (!formData.get('contact[accepts_marketing]')) formData.set('contact[accepts_marketing]', 'true');
            if (!formData.get('contact[tags]')) formData.set('contact[tags]', 'newsletter');
            if (!formData.get('challenge')) formData.set('challenge', 'false');
            if (!formData.get('form_type')) formData.set('form_type', 'customer');

            // Aggiungi il token captcha alla richiesta
            if (token) {
              formData.set('captcha_token', token);
            }

            var requestPath = resolveRequestPath();
            var requestUrl = joinWithRoot(requestPath);

            return fetch(requestUrl, {
              method: form.method || 'POST',
              headers: {
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: formData,
              credentials: 'same-origin',
            });
          })
          .then(function (response) {
            if (!response) throw new Error('missing-response');

            if (response.redirected && response.url.indexOf('/challenge') !== -1) {
              setMessage('error', messages.captcha);
              return;
            }

            var contentType = response.headers.get('content-type') || '';
            if (contentType.indexOf('application/json') !== -1) {
              return response.json().then(function (data) {
                var errors = data && data.errors;
                var hasErrors = false;

                if (Array.isArray(errors)) {
                  hasErrors = errors.length > 0;
                } else if (typeof errors === 'string') {
                  hasErrors = errors.length > 0;
                } else if (errors && typeof errors === 'object') {
                  hasErrors = Object.keys(errors).length > 0;
                }

                if ((data && data.status === 'success') || (!hasErrors && response.ok)) {
                  setMessage('success');
                  form.reset();
                } else {
                  setMessage('error', getErrorMessage(errors));
                }
              });
            }

            return response.text().then(function (text) {
              if (/captcha|challenge/i.test(text)) {
                setMessage('error', messages.captcha);
              } else if (/errors?[^<]*email/i.test(text) || /invalid/i.test(text)) {
                setMessage('error');
              } else {
                setMessage('success');
                form.reset();
              }
            });
          })
          .catch(function (error) {
            if (error && error.message && error.message.indexOf('captcha') !== -1) {
              console.error('Captcha error:', error);
              setMessage('error', messages.captcha);
            } else {
              console.error('Newsletter submission error:', error);
              setMessage('error');
            }
          })
          .finally(function () {
            setLoading(false);
          });
      });
    };

    var init = function (scope) {
      var context = scope instanceof Element ? scope : document;
      var wrappers = toArray(context.querySelectorAll('[data-newsletter-wrapper]'));
      for (var i = 0; i < wrappers.length; i += 1) {
        bindWrapper(wrappers[i]);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-listing-with-filters"]) return;
  try {
    
  class ProductListingWithFilters {
    constructor(container) {
      this.container = container;
      this.sidebar = container.querySelector('[data-filters-sidebar]');
      this.toggle = container.querySelector('[data-filters-toggle]');
      this.closeBtn = container.querySelector('[data-filters-close]');
      this.overlay = container.querySelector('[data-filters-overlay]');
      this.sortSelect = container.querySelector(`#SortBy-${container.dataset.sectionId || ''}`);

      this.bindEvents();
    }

    bindEvents() {
      if (this.toggle) {
        this.toggle.addEventListener('click', () => this.openSidebar());
      }

      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.closeSidebar());
      }

      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.closeSidebar());
      }

      if (this.sortSelect) {
        this.sortSelect.addEventListener('change', (e) => this.handleSortChange(e));
      }

      // Close sidebar on escape
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.sidebar && this.sidebar.getAttribute('aria-expanded') === 'true') {
          this.closeSidebar();
        }
      });

      // Handle window resize
      window.addEventListener('resize', () => this.handleResize());
    }

    openSidebar() {
      if (!this.sidebar) return;

      this.sidebar.setAttribute('aria-expanded', 'true');
      this.toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';

      // Focus management
      const firstFocusable = this.sidebar.querySelector(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (firstFocusable) {
        firstFocusable.focus();
      }
    }

    closeSidebar() {
      if (!this.sidebar) return;

      this.sidebar.setAttribute('aria-expanded', 'false');
      this.toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';

      // Return focus to toggle
      if (this.toggle) {
        this.toggle.focus();
      }
    }

    handleSortChange(e) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', e.target.value);
      window.location.href = url.toString();
    }

    handleResize() {
      if (window.innerWidth >= 1024) {
        this.closeSidebar();
      }
    }
  }

  // Initialize
  document.addEventListener('DOMContentLoaded', function () {
    const containers = document.querySelectorAll('[data-section-type="product-listing-with-filters"]');
    containers.forEach((container) => {
      new ProductListingWithFilters(container);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const qtyButtons = document.querySelectorAll('.qty__button');
    const qtyInput = document.querySelector('.qty__input');
    const deliveryWrapper = document.querySelector('.delivery-window-wrapper');
    const deliveryNotice = document.querySelector('.delivery-window-notice');
    const deliverySelect = document.querySelector('select[name="properties[Delivery date and time]"]');
    const addToCartBtn = document.querySelector('.product-submit');
    const postalField = document.querySelector('.delivery-cap-field');
    const postalInput = postalField ? postalField.querySelector('input[name="properties[Delivery postal code]"]') : null;
    const postalMessage = postalField ? postalField.querySelector('.delivery-cap-message') : null;
    const requiresCap =
      !!postalField && deliveryWrapper && deliveryWrapper.getAttribute('data-requires-cap') === 'true';
    const rawCapsValue = deliveryWrapper ? deliveryWrapper.getAttribute('data-available-caps') : null;
    const allowedCaps = parseAllowedCaps(rawCapsValue);
    const normalizedAllowedCaps = allowedCaps.map((cap) => normalizeCap(cap)).filter(Boolean);
    const hasConfiguredCaps = normalizedAllowedCaps.length > 0;

    function normalizeCap(value) {
      return value ? value.toString().replace(/\s+/g, '').toLowerCase() : '';
    }

    function parseAllowedCaps(rawValue) {
      if (!rawValue || rawValue === 'null' || rawValue === 'undefined') {
        return [];
      }

      try {
        const parsed = JSON.parse(rawValue);
        if (Array.isArray(parsed)) {
          return parsed;
        }

        if (typeof parsed === 'string') {
          return parsed.split(/[,\s]+/);
        }
      } catch (error) {
        return rawValue.split(/[,\s]+/);
      }

      return [];
    }

    function getDeliveryState() {
      const currentQty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      const minAmount = deliveryWrapper ? parseInt(deliveryWrapper.getAttribute('data-min-amount'), 10) || 1 : 1;
      const meetsMinimum = currentQty >= minAmount;
      const hasPostalField = Boolean(postalInput && requiresCap);
      const rawPostal = postalInput ? postalInput.value : '';
      const normalizedPostal = normalizeCap(rawPostal);
      const hasPostal = normalizedPostal.length > 0;
      const capAllowed = hasPostalField
        ? hasPostal && (hasConfiguredCaps ? normalizedAllowedCaps.includes(normalizedPostal) : true)
        : false;
      const shouldShowDelivery =
        meetsMinimum && (!hasPostalField || (hasPostal && capAllowed));

      return {
        currentQty,
        minAmount,
        meetsMinimum,
        hasPostalField,
        hasPostal,
        capAllowed,
        shouldShowDelivery,
      };
    }

    function updateCapMessage(state) {
      if (!postalField || !postalMessage) return;

      postalField.classList.remove('is-error', 'is-valid');
      postalMessage.textContent = '';

      if (!state.hasPostalField) {
        return;
      }

      if (!state.hasPostal) {
        return;
      }

      if (state.capAllowed) {
        const validMessage = postalField.getAttribute('data-valid-message');
        if (validMessage) {
          postalMessage.textContent = validMessage;
          postalField.classList.add('is-valid');
        }
      } else {
        const invalidMessage = postalField.getAttribute('data-invalid-message');
        if (invalidMessage) {
          postalMessage.textContent = invalidMessage;
          postalField.classList.add('is-error');
        }
      }
    }

    // Function to update delivery window visibility
    function updateDeliveryWindow() {
      const state = getDeliveryState();

      if (!deliveryWrapper || !qtyInput) {
        updateCapMessage(state);
        updateAddToCartButton(state);
        return;
      }

      if (state.shouldShowDelivery) {
        deliveryWrapper.style.display = 'block';
      } else {
        deliveryWrapper.style.display = 'none';
        if (deliverySelect) {
          deliverySelect.value = '';
        }
      }

      if (deliveryNotice) {
        const showNotice = !state.meetsMinimum && (!state.hasPostalField || (state.hasPostal && state.capAllowed));
        deliveryNotice.style.display = showNotice ? 'flex' : 'none';
      }

      updateCapMessage(state);
      updateAddToCartButton(state);
    }

    // Function to update Add to Cart button state
    function updateAddToCartButton(stateParam) {
      if (!addToCartBtn) return;

      const state = stateParam || getDeliveryState();

      if (state.shouldShowDelivery && deliverySelect) {
        const hasSelectedDate = deliverySelect.value !== '';
        addToCartBtn.disabled = !hasSelectedDate;
      } else {
        addToCartBtn.disabled = false;
      }
    }

    // Quantity stepper click handlers
    if (qtyInput && qtyButtons.length) {
      qtyButtons.forEach((button) => {
        button.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          const isIncrement = button.getAttribute('name') === 'plus';
          let currentValue = parseInt(qtyInput.value) || 1;

          if (isIncrement) {
            currentValue++;
          } else if (currentValue > 1) {
            currentValue--;
          }

          qtyInput.value = currentValue;

          // Trigger change event
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));

          // Update delivery window visibility
          updateDeliveryWindow();
        });
      });

      // Update on manual input change
      qtyInput.addEventListener('input', function () {
        updateDeliveryWindow();
      });

      qtyInput.addEventListener('change', function () {
        updateDeliveryWindow();
      });
    }

    if (postalInput) {
      postalInput.addEventListener('input', function () {
        updateDeliveryWindow();
      });

      postalInput.addEventListener('blur', function () {
        updateCapMessage(getDeliveryState());
      });
    }

    // Update button when delivery date is selected
    if (deliverySelect) {
      deliverySelect.addEventListener('change', updateAddToCartButton);
    }

    // Initial check
    updateDeliveryWindow();

    // Thumbnail gallery functionality
    const thumbButtons = document.querySelectorAll('.thumb-btn');
    const mainImage = document.querySelector('.gallery-main img');

    if (thumbButtons.length && mainImage) {
      thumbButtons.forEach((thumb) => {
        thumb.addEventListener('click', function () {
          const thumbImg = this.querySelector('img');
          const imageId = this.getAttribute('data-media-id');

          // Get the base URL without size parameters
          let thumbSrc = thumbImg.src;

          // Remove size parameters and construct new URL for main image
          // Handle both old format (_160x160) and new format (?width=160)
          let newSrc;
          if (thumbSrc.includes('?width=')) {
            // New format: replace width parameter
            newSrc = thumbSrc.replace(/(\?|&)width=\d+/, '$1width=1200');
          } else {
            // Old format or no parameters: replace size suffix or add width parameter
            if (thumbSrc.includes('_')) {
              newSrc = thumbSrc.replace(/_\d+x\d*(\.|$)/, '_1200x$1');
            } else {
              newSrc = thumbSrc + (thumbSrc.includes('?') ? '&' : '?') + 'width=1200';
            }
          }

          // Update main image
          mainImage.src = newSrc;

          // Update srcset for responsive images
          if (mainImage.hasAttribute('srcset')) {
            const baseSrc = newSrc.split('?')[0].replace(/_\d+x\d*/, '');
            const newSrcset = [
              baseSrc + '?width=400 400w',
              baseSrc + '?width=600 600w',
              baseSrc + '?width=800 800w',
              baseSrc + '?width=1200 1200w',
            ].join(', ');
            mainImage.setAttribute('srcset', newSrcset);
          }

          // Update alt text
          if (thumbImg.alt) {
            mainImage.alt = thumbImg.alt;
          }

          // Update active state
          thumbButtons.forEach((t) => t.classList.remove('active'));
          this.classList.add('active');
        });
      });
    }

    // Product form submission
    const productForm = document.querySelector('#ProductForm');
    if (productForm) {
      const submitBtn = productForm.querySelector('.product-submit');
      const addText = productForm.querySelector('.add-to-cart-text');
      const addingText = productForm.querySelector('.adding-to-cart-text');
      const addedText = productForm.querySelector('.added-to-cart-text');

      productForm.addEventListener('submit', function (e) {
        e.preventDefault();

        // Validate delivery prerequisites
        const deliveryDateTime = productForm.querySelector('select[name="properties[Delivery date and time]"]');
        const currentState = getDeliveryState();

        if (currentState.shouldShowDelivery && deliveryDateTime && !deliveryDateTime.value) {
          deliveryDateTime.focus();
          alert('Please select a delivery date and time.');
          return;
        }

        // Disable button and show loading state
        submitBtn.disabled = true;
        addText.style.display = 'none';
        addingText.style.display = 'block';

        // Get form data
        const formData = new FormData(productForm);
        const id = formData.get('id');
        const quantity = formData.get('quantity') || 1;

        // Collect all properties (delivery date, slot, phone, etc.)
        const properties = {};
        for (let [key, value] of formData.entries()) {
          if (key.startsWith('properties[') && value) {
            const propName = key.match(/properties\[(.*?)\]/)[1];
            properties[propName] = value;
          }
        }

        // Use Shopify AJAX API to add to cart
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            items: [
              {
                id: parseInt(id),
                quantity: parseInt(quantity),
                properties: Object.keys(properties).length > 0 ? properties : undefined,
              },
            ],
          }),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error('Error adding to cart');
            }
            return response.json();
          })
          .then((data) => {
            // Show success state
            addingText.style.display = 'none';
            addedText.style.display = 'block';

            // Emetti evento per aggiornare altri componenti
            document.dispatchEvent(new CustomEvent('cart:updated'));

            // Reset after 2 seconds
            setTimeout(() => {
              addedText.style.display = 'none';
              addText.style.display = 'block';
              submitBtn.disabled = false;
            }, 2000);
          })
          .catch((error) => {
            console.error('Error:', error);
            addingText.style.display = 'none';
            addText.style.display = 'block';
            submitBtn.disabled = false;
            alert('There was an error adding this item to the cart. Please try again.');
          });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stockists"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const filters = document.querySelectorAll('[data-filter]');

    filters.forEach((filter) => {
      filter.addEventListener('change', function () {
        // Implement filter logic here
        console.log('Filter changed:', this.dataset.filter, this.value || this.checked);
      });
    });

    const mapButtons = document.querySelectorAll('[data-load-map]');
    mapButtons.forEach((button) => {
      button.addEventListener('click', function () {
        // Implement map loading logic here
        console.log('Load map clicked');
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
